const $ = jQuery;

module.exports = class {
    #$modal;
    #$modalHeader;
    #$modalBody;
    #$modalFooter;
    #$modalBackdrop;

    #config = {
        id: 'lumeris-modal',
        modalClass: '',
        modalHeaderClass: '',
        header: null,
        headerClass: '',
        subheader: null,
        subheaderClass: '',
        modalBodyClass: '',
        button: null,
        buttonClass: '',
        buttonDisabled: false,
        altButton: '',
        altButtonClass: 'no-style',
        altButtonDisabled: false,
        modalFooterClass: '',
        cancelButton: true,
        backdropClass: '',
        destroyOnCancel: true
    };

    #data = {};

    #active = false;

	constructor(config) {
		if (typeof config === 'undefined') {
			return false;
		}

        this.#config = {...this.#config, ...config};

        this.#$modal = $('<div id="' + this.config.id +'" class="lumeris-modal '+ this.config.modalClass + '" tabindex="-1" role="dialog" aria-hidden="true">' +
            '<div class="lumeris-modal-dialog" role="document">' +
                '<div class="lumeris-modal-content">' +
                    '<div class="lumeris-modal-header ' + this.config.modalHeaderClass + '"></div>' +
                    '<div class="lumeris-modal-body ' + this.config.modalBodyClass + '"></div>' +
                    '<div class="lumeris-modal-footer ' + this.config.modalFooterClass + '"></div>' +
                '</div>' +
            '</div>' +
        '</div>');

        this.#$modalHeader = this.$modal.find('.lumeris-modal-header');
        this.#$modalBody = this.$modal.find('.lumeris-modal-body');
        this.#$modalFooter = this.$modal.find('.lumeris-modal-footer');
        this.#$modalBackdrop = $('<div id="lumeris-modal-backdrop" class="lumeris-modal-backdrop ' + this.config.backdropClass + '" aria-hidden="true"></div>');

        this.build();
		this.bind();

        $('body').append(this.$modal).append(this.$modalBackdrop);
	}

    bind() {
        this.$modal.on('lumeris-modal:show', (event) => { this.onModalShow(event); });
        this.$modal.on('lumeris-modal:hide', (event) => { this.onModalHide(event); });

        if (typeof this.$button !== 'undefined' && this.$button.length !== 0) {
            this.$button.on('click', (event) => { this.onButtonClick(event); });
        }

        if (typeof this.$altButton !== 'undefined' && this.$altButton.length !== 0) {
            this.$altButton.on('click', (event) => { this.onAltButtonClick(event); });
        }

        if (typeof this.$cancelButton !== 'undefined' && this.$cancelButton.length !== 0) {
            this.$cancelButton.on('click', (event) => { this.onCancelButtonClick(event); });
        }
    }

    get config() {
        return this.#config;
    }

    get data() {
        return this.#data;
    }

    get active() {
        return this.#active;
    }

    get $modal() {
        return this.#$modal;
    }

    get $modalHeader() {
        return this.#$modalHeader;
    }

    get $modalBody() {
        return this.#$modalBody;
    }

    get $modalFooter() {
        return this.#$modalFooter;
    }

    get $modalBackdrop() {
        return this.#$modalBackdrop;
    }

    set data(val={}) {
        this.#data = val;
    }

    set active(val=false) {
        this.#active = val;
    }

    build() {
        if (this.config.header) {
            this.appendHeaderContent($(`<h3 class="${this.config.headerClass}">${this.config.header}</h3>`));
        }

        if (this.config.subheader) {
            this.appendHeaderContent($(`<h5 class="${this.config.subheaderClass}">${this.config.subheader}</h5>`));
        }

        if (this.config.button) {
            this.$button = $(`<button class="${this.config.buttonClass}" type="button" ${(this.config.buttonDisabled) ? 'disabled' : ''}>${this.config.button}</button>`);
            const $buttonContainer = $('<div class="button-container"></div>');
            $buttonContainer.append(this.$button);
            this.appendBodyContent($buttonContainer);
        }

        if (this.config.altButton) {
            this.$altButton = $(`<button class="${this.config.altButtonClass}" type="button" ${(this.config.altButtonDisabled) ? 'disabled' : ''}>${this.config.altButton}</button>`);
            const $altButtonContainer = $('<div class="alt-button-container"></div>');
            $altButtonContainer.append(this.$altButton);
            this.appendFooterContent($altButtonContainer);
        }

        if (this.config.cancelButton === true) {
            this.$cancelButton = $('<button type="button" class="cancel">Cancel</button>');
            let $cancelButtonContainer = $('<div class="cancel-button-container"></div>');
            $cancelButtonContainer.append(this.$cancelButton);
            this.appendFooterContent($cancelButtonContainer);
        }
    }

    isActive() {
        return this.active;
    }

    appendHeaderContent($content) {
        this.$modalHeader.append($content);
    }

    prependHeaderContent($content) {
        this.$modalHeader.prepend($content);
    }

    appendBodyContent($content) {
        this.$modalBody.append($content);
    }

    prependBodyContent($content) {
        this.$modalBody.prepend($content);
    }

    appendFooterContent($content) {
        this.$modalFooter.append($content);
    }

    prependFooterContent($content) {
        this.$modalFooter.prepend($content);
    }

    show() {
        this.active = true;
        this.$modal.attr('aria-hidden', 'false');
        this.$modalBackdrop.attr('aria-hidden', 'false');
    }

    hide() {
        this.active = false;
        this.$modal.attr('aria-hidden', 'true');
        this.$modalBackdrop.attr('aria-hidden', 'true');
    }

    destroy() {
        this.active = false;
        this.$modal.remove();
        this.$modalBackdrop.remove();
    }

    trigger(eventName) {
        this.$modal.trigger(eventName);
    }

    on(event, callback) {
        this.$modal.on(event, callback);
    }

    onModalShow(event) {
        if (!event) {
            return false;
        }
        this.show();
    }

    onModalHide(event) {
        if (!event) {
            return false;
        }
        this.hide();
    }

    onButtonClick(event) {
        if (!event instanceof Event) {
            return false;
        }

        this.trigger('lumeris-modal:buttonClick');
    }

    onAltButtonClick(event) {
        if (!event instanceof Event) {
            return false;
        }

        this.trigger('lumeris-modal:altButtonClick');
    }

    onCancelButtonClick(event) {
        if (!event instanceof Event) {
            return false;
        }
        this.trigger('lumeris-modal:cancelButtonClick');

        if (this.config.destroyOnCancel) {
            this.destroy();
        } else {
            this.hide();
        }
    }
    
}